/**
 * Discovery / prospector thread continuity helpers.
 * Server resume is authoritative; localStorage is only a same-browser hint.
 */

export function prospectorThreadStorageKey(userId: string, companyId: string): string {
  return `krysalis_prospector_thread_${userId}_${companyId}`;
}

export function prospectorClaudeRefStorageKey(userId: string, companyId: string): string {
  return `krysalis_prospector_claude_ref_${userId}_${companyId}`;
}

/** Read cached thread id; migrates sessionStorage → localStorage once. */
export function readCachedProspectorThreadId(userId: string, companyId: string): string | null {
  if (typeof window === 'undefined') return null;
  const key = prospectorThreadStorageKey(userId, companyId);
  try {
    const fromLocal = localStorage.getItem(key)?.trim();
    if (fromLocal) return fromLocal;
    const fromSession = sessionStorage.getItem(key)?.trim();
    if (fromSession) {
      localStorage.setItem(key, fromSession);
      sessionStorage.removeItem(key);
      return fromSession;
    }
  } catch {
    /* private mode / quota */
  }
  return null;
}

export function writeCachedProspectorThreadId(
  userId: string,
  companyId: string,
  threadId: string
): void {
  if (typeof window === 'undefined') return;
  const key = prospectorThreadStorageKey(userId, companyId);
  try {
    localStorage.setItem(key, threadId);
    sessionStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function readCachedClaudeProjectRef(userId: string, companyId: string): string | undefined {
  if (typeof window === 'undefined') return undefined;
  const key = prospectorClaudeRefStorageKey(userId, companyId);
  try {
    return localStorage.getItem(key)?.trim() || sessionStorage.getItem(key)?.trim() || undefined;
  } catch {
    return undefined;
  }
}
